import React from 'react'
import styled from 'styled-components'
import { Borders, Colors } from '../../constants'
import { Refresh } from '../../common'

interface Props {
  onClick: () => void
}

export function RefreshButton({ onClick }: Props) {
  return (
    <Button title="Refresh" onClick={onClick}>
      <RefreshStyled />
    </Button>
  )
}

const Button = styled.button`
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: ${Colors.Gray};
  background-color: #2f323a;
  border: 0;
  border-radius: ${Borders.Radius};
  outline: 0;
  cursor: pointer;

  &:hover {
    color: ${Colors.White};
    background-color: ${Colors.Hover};

    svg {
      transform: rotate(360deg);
    }
  }
`

const RefreshStyled = styled(Refresh)`
  width: 16px;
  height: 16px;
  transition: fill 0.5s, stroke 0.5s, transform 1s;
`
